import { withAuthenticationRequired } from "@auth0/auth0-react";
import { ComponentType } from "react";
import { useAuthContext } from "../contexts/auth/useAuthContext";
import GlobalLoader from "../pages/GlobalLoader";

export const AuthenticationGuard = <P extends object>({
  component,
}: {
  component: ComponentType<P>;
}): JSX.Element => {
  const { isAuthenticatedFromUrl } = useAuthContext();
  const props = {};

  // If the user is authenticated from the URL, we can render the component directly, without relying on Auth0's authentication flow.
  if (isAuthenticatedFromUrl) {
    const AuthenticatedComponent = (props: P): JSX.Element => {
      const Component = component as ComponentType<P>;
      return <Component {...props} />;
    };
    return <AuthenticatedComponent {...(props as P)} />;
  }

  const WrappedComponent = withAuthenticationRequired(component, {
    onRedirecting: () => <GlobalLoader />,
  });

  return <WrappedComponent {...(props as P)} />;
};
